<template>
    <div class="page-container">
        <div class="area-container">
            <div class="area-tools">
                <el-icon>
                    <Expand />
                </el-icon>
                模块筛选
            </div>
            <el-scrollbar>
                <ul class="unit-list" v-for="item in moduleOptionLists" :key="item.id" @click="changeMoudle(item.id)">
                    <li class="unit-item" :class="{ active: item.id == currentModule }" :title="item.name">
                        {{ item.name }}
                    </li>
                </ul>
            </el-scrollbar>
        </div>
        <div class="data-container">
            <div class="tool-box">
                <el-button type="primary" :icon="Refresh" @click="resetQueryForm">刷新</el-button>
                <el-button type="primary" :icon="Plus" v-permission="['dict:add']" @click="onAddClick()">添加</el-button>
                <el-button :icon="Download" @click="importsVisible = true" v-permission="['dict:import']">导入</el-button>
                <el-button @click="handleExport" v-permission="['dict:export']" :icon="Upload">导出</el-button>
                <el-button :icon="DCaret" @click="handleSort">一键排序</el-button>
                <el-button :icon="Refresh" @click="handlrefresh">刷新缓存</el-button>
            </div>
            <el-form class="search-form" :inline="true" :model="search_data" label-position="top">
                <el-form-item label="字典名称">
                    <el-input v-model="search_data.name" clearable placeholder="请输入" style="width: 150px" />
                </el-form-item>
                <el-form-item label="字典类型">
                    <el-input v-model="search_data.code" clearable placeholder="请输入" style="width: 150px" />
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="search_data.status" clearable placeholder="请选择" style="width: 150px">
                        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="创建时间">
                    <el-date-picker
                        v-model="search_data.date"
                        value-format="YYYY-MM-DD"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :icon="Search" @click="searchPage">搜索</el-button>
                    <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="table_data" v-loading="tableLoading" border style="width: 100%" row-key="id">
                <el-table-column label="序号" width="60" type="index"></el-table-column>
                <el-table-column prop="name" label="字典名称"></el-table-column>
                <el-table-column prop="code" label="字典类型">
                    <template #default="{ row }">
                        <span class="code" @click="$router.push({ path: `/dictdata/${row.id}` })">
                            {{ row.code }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="preset" label="预设" width="80">
                    <template #default="{ row }">
                        <el-tag v-if="row.preset">是</el-tag>
                        <el-tag v-else type="info">否</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="80">
                    <template #default="{ row }">
                        <el-tag v-if="row.status == 1">正常</el-tag>
                        <el-tag v-else type="danger">停用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column prop="list_order" label="字典排序" width="130">
                    <template #default="scope">
                        <el-input-number
                            style="width: 100px"
                            type="number"
                            v-model="scope.row.list_order"
                            :min="0"
                            :max="999999"
                            controls-position="right"
                            size="small"
                        />
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间" sortable width="180"></el-table-column>
                <el-table-column label="操作" width="200">
                    <template #default="{ row }">
                        <el-button type="primary" link :icon="Edit" @click="onEditClick(row)" v-permission="['dict:add']">
                            修改
                        </el-button>
                        <el-button type="primary" link :icon="Delete" @click="onRemoveClick(row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 50]"
                :page-size="search_data.page_size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
            <forms-dialog
                v-model="formDialogVisible"
                :isForm="isForm"
                :roleId="selectId"
                @updateForm="getTableData"
                :module="currentModule"
                :modList="modList"
            ></forms-dialog>
            <imports-form
                v-if="importsVisible"
                v-model="importsVisible"
                @updateForm="getTableData"
                menuCode="dict"
            ></imports-form>
        </div>
    </div>
</template>

<script setup>
import { onActivated, onMounted, ref, watch } from 'vue'
import { batchSort, delDict, dictRefresh, getDictLists } from '@/api/dict.js'
import FormsDialog from './components/dialog.vue'
import ImportsForm from '@/components/ImportsForm.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { DCaret, Delete, Download, Edit, Plus, Refresh, Search, Upload } from '@element-plus/icons'
import { getModuleOptionLists } from '@/api/module'

const modList = ref([])
const tableLoading = ref(true)
const table_data = ref([])
const search_data = ref({
    name: '',
    code: '',
    status: '',
    page: 1,
    page_size: 10,
    start_time: '',
    end_time: '',
    list_order: '1'
})
const currentModule = ref('')
// 获取字典管理列表
const getTableData = async () => {
    tableLoading.value = true
    const startTime = search_data.value?.date?.[0] ?? ''
    const endTime = search_data.value.date?.[1] ?? ''
    const parmas = { ...search_data.value, start_time: startTime, end_time: endTime }
    const moduleId = currentModule.value
    delete parmas.date
    const result = await getDictLists({ ...parmas, module: moduleId })
    tableLoading.value = false
    table_data.value = result.lists
    total.value = result.total
}
getTableData()
const getModuleListData = async () => {
    const data = await getModuleOptionLists()
    modList.value = data
}
const moduleOptionLists = ref([])
const moduleOptionObj = ref({})
// 获取数据的方法
const getModuleOptionListsData = async () => {
    const moduleOptionRes = await getModuleOptionLists({})
    moduleOptionLists.value = moduleOptionRes
    currentModule.value = moduleOptionRes[0].id
    getTableData()
    const optionObj = {}
    moduleOptionRes.forEach((item) => {
        optionObj[item.id] = item.name
    })
    moduleOptionObj.value = optionObj
    getModuleListData()
}
const changeMoudle = (id) => {
    currentModule.value = id
    getTableData()
}

const total = ref(0)
const statusOptions = [
    { label: '正常', value: 1 },
    { label: '停用', value: 0 }
]
// 重置
const resetQueryForm = () => {
    Object.keys(search_data.value).forEach((key) => {
        if (key !== 'page' && key !== 'page_size') search_data.value[key] = ''
    })
    getTableData()
}
const formVisible = ref(true)

getTableData()

const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const selectId = ref('') // 点中的运营单位id
// 保证每次打开重新获取数据
watch(formDialogVisible, (val) => {
    if (!val) {
        selectId.value = ''
    }
})

// 分页相关
// page_size 改变触发
const handleSizeChange = (currentSize) => {
    search_data.value.page_size = currentSize
    getTableData()
}
// 页码改变触发
const handleCurrentChange = (currentPage) => {
    search_data.value.page = currentPage
    getTableData()
}
// 搜索回到第一页
const searchPage = () => {
    search_data.value.page = 1
    getTableData()
}
// 刷新缓存
const handlrefresh = async () => {
    const err = await dictRefresh().catch((err) => {
        tableLoading.value = false
        return err
    })
    if (err) return
    // 修改成功
    ElMessage.success('刷新缓存成功！')
}

// 编辑
const onEditClick = (row) => {
    selectId.value = row.id
    isForm.value = true
    formDialogVisible.value = true
}
// 添加
const onAddClick = () => {
    selectId.value = ''
    isForm.value = true
    formDialogVisible.value = true
}
// 删除

const onRemoveClick = (row) => {
    ElMessageBox.confirm('确定要删除 ' + row.name + ' 吗？', {
        type: 'warning'
    })
        .then(async () => {
            await delDict(row.id)
            ElMessage.success('删除成功！')
            // 重新渲染数据
            getTableData()
        })
        .catch(() => {})
}
// 排序
const handleSort = async () => {
    const soreObj = {}
    if (table_data.value.length === 0) return
    table_data.value.forEach((ele) => {
        soreObj[ele.id] = ele.list_order
    })
    await batchSort(soreObj)
    ElMessage.success('操作成功')
    getTableData()
}

// 导出
const handleExport = () => {
    ElMessageBox.confirm('是否确认导出字典列表', '提示', {
        type: 'warning'
    })
        .then(async () => {
            const code = table_data.value.filter((v) => v.name === search_data.value.name)[0]?.code
            const data = await getDictLists({ ...search_data.value, code, export: 1 })
            console.log(search_data.value, 'search_data.value')
            window.open(data.data)
            ElMessage({
                type: 'success',
                message: '导出成功'
            })
        })
        .catch(() => {})
}
// 导入
const importsVisible = ref(false)

// 被 keep-alive 缓存的组件激活时调用
onActivated(() => {
    getTableData()
})
onMounted(() => {
    getModuleOptionListsData()
})
</script>

<style lang="scss" scoped>
.area-tools {
    padding: 10px 20px;
    line-height: 28px;
    color: #7c7e82;
    border-bottom: 1px solid #eeeeee;
    font-size: 14px;
}
</style>
